import React from 'react';

import type { AppDependent } from 'src/services/api/appBuilderApi';
import { getBuilderSessionPath } from 'src/utils/ExtensionUtils';

/** Names the apps that would lose a dependency; the admin can still go ahead. */
export const DependentsWarning: React.FC<{
  appName: string;
  dependents?: AppDependent[];
}> = ({ appName, dependents }) => {
  if (!dependents?.length) return null;
  return (
    <div className="mb-3 text-sm" role="alert">
      <p>
        {dependents.length === 1 ? 'This app is' : 'These apps are'} using{' '}
        {appName}, and may stop working:
      </p>
      <ul className="list-disc pl-5">
        {dependents.map((dependent) => (
          <li key={dependent.appId}>
            <a
              href={getBuilderSessionPath(dependent.appBuilderId)}
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              {dependent.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
